module.exports = __webpack_public_path__ + "static/media/iphones.74fa21b2.png";